import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";

export function AdminBonusPuzzle({ puzzles = [] }) {
  const [selected, setSelected] = useState("");
  const [current, setCurrent] = useState(null);
  const [message, setMessage] = useState("");
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let cancelled = false;
    api.get("/game/bonus-puzzle").then(({ data }) => {
      if (cancelled) return;
      setCurrent(data.puzzle);
      setSelected(data.puzzle_id || "");
      setReady(true);
    }).catch(e => { if (!cancelled) setMessage(apiError(e)); });
    return () => { cancelled = true; };
  }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/game/bonus-puzzle", { puzzle_id: selected });
      setCurrent(data.puzzle);
      setMessage("Bonus puzzle designated. Existing earned puzzle access is preserved.");
    } catch (e) { setMessage(apiError(e)); }
    finally { setBusy(false); }
  };
  return <section className="border border-white/15 bg-card p-5 mb-6 space-y-3" data-testid="admin-login-bonus">
    <h2 className="font-display text-2xl">SEVEN-DAY LOGIN BONUS</h2>
    <p className="text-sm text-muted-foreground">Current: {current?.title || "No Bonus-Only puzzle designated"}. Players earn access after each seven consecutive login days. Only approved Bonus-Only puzzles are eligible. Designate a different puzzle when you want future rewards to use it.</p>
    <label className="block text-sm" htmlFor="login-bonus-puzzle">Bonus puzzle</label>
    <select id="login-bonus-puzzle" value={selected} onChange={e => setSelected(e.target.value)} className="w-full bg-background border border-white/20 px-3 py-2" disabled={!ready || busy}>
      <option value="">Select an approved Bonus-Only puzzle</option>
      {puzzles.filter(puzzle => puzzle.status === "approved" && puzzle.bonus_only === true && ["casual", "golden_era"].includes(puzzle.zone)).map(puzzle => <option key={puzzle.puzzle_id} value={puzzle.puzzle_id}>{puzzle.title} ({puzzle.zone === "casual" ? "New Jack" : "Triple OG"})</option>)}
    </select>
    <button type="button" onClick={save} disabled={!ready || !selected || busy} className="border border-primary bg-primary text-primary-foreground px-4 py-2 text-sm disabled:opacity-50" data-testid="admin-set-login-bonus">{busy ? "Saving…" : "Set Bonus Puzzle"}</button>
    {message && <p role="status" className="text-sm">{message}</p>}
  </section>;
}
